module.exports = __webpack_public_path__ + "img/3 steps mobile view.255294cd.svg";